@if (!edit) {
  <div [innerHTML]="form.controls.note.value | safeHtml"></div>
  @for (note of sharingFoldersNotes(); track $index) {
    <div class="name-container">
      <div class="note-divider"></div>
      <div>{{ note.serviceName }}</div>
      <div class="note-divider"></div>
    </div>
    <div [innerHTML]="note.note | safeHtml"></div>
  }
} @else {
  <app-input-wysiwyg
    [form]="form"
    id="note"
    editorKey="FolderNote"
  ></app-input-wysiwyg>
  <div class="dialogButtons">
    <app-action-buttons (primaryClickEvent)="save()" (secondaryClickEvent)="this.toggleEdit()"></app-action-buttons>
  </div>
}

